import {FC, Fragment, memo} from 'react'
import {TextInputV2} from '../../../components/TextInputV2'
import {useTranslation} from 'react-i18next'
import {Form} from 'react-bootstrap'
import Pagination from '../component/Pagination'
import {Selection} from '../../../components/Selection'
import {SECTOR_OPTIONS} from '../../../constants'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {contractSelector, setSipFilter} from '../../../redux/slices/contractSlices'
import * as TableUI from '../../../components/Table/Table'
import styled from 'styled-components'
import i18next from 'i18next'

export interface TableBrowseSIPProps {
  data: any
  paginateNumber: any
  numberUrls: string[]
  tooltip: string
  onSipSelected: (item: any) => void
  onToggleExpand: (e: any) => void
}

export const TableBrowseSIP: FC<TableBrowseSIPProps> = (props) => {
  return (
    <Fragment>
      <TableUI.TableWrapper style={{marginBottom: '1rem'}}>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>

          <TableUI.TBody>
            <RowFilter />
            <RowData {...props} />
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={props.paginateNumber} test={props.numberUrls} />
    </Fragment>
  )
}

const StyledFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`

// eslint-disable-next-line react/display-name
export const RowHead = memo(() => {
  const {t} = useTranslation()
  return (
    <tr>
      <th style={
        {
          width:'100px'
        }
      }></th>
      <th>{t('SIP Number')}</th>
      <th>{t('order-pembeli')}</th>
      <th>{t('Sektor')}</th>
    </tr>
  )
})

// eslint-disable-next-line react/display-name
export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {sipFilter} = useAppSelector(contractSelector)
  const dispatch = useAppDispatch()

  return (
    <tr style={{backgroundColor: 'white'}}>
      <td>&nbsp;</td>
      <td>
        <TextInputV2
          placeholder={t('SIP Number')}
          value={sipFilter?.SIP_number ?? ''}
          onChange={({target}) => dispatch(setSipFilter({...sipFilter, SIP_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pembeli')}
          value={sipFilter?.customer_name ?? ''}
          onChange={({target}) =>
            dispatch(setSipFilter({...sipFilter, customer_name: target.value}))
          }
        />
      </td>
      <td>
        <Selection
          placeholder={t('Sektor')}
          data={SECTOR_OPTIONS}
          value={sipFilter?.sector_id ?? ''}
          onChange={(sector_id) => dispatch(setSipFilter({...sipFilter, sector_id}))}
        />
      </td>
    </tr>
  )
})

export const RowData = (props: TableBrowseSIPProps) => {
  const {t} = useTranslation()

  return (
    <>
      {props.data.map((item: any, index: number) => (
        <Fragment key={index}>
          <tr>
            <td>
              <StyledFlexCenter>
                <Form.Check
                  reverse
                  type='checkbox'
                  id={item?.customer_code}
                  onChange={() => props.onSipSelected(item)}
                />
              </StyledFlexCenter>
            </td>
            <td>
              <StyledFlexCenter>
                <button
                  className='iconArow d-flex justify-content-center align-items-center'
                  data-target={'target' + item?.SIP_number}
                  title={t(props.tooltip)}
                  onClick={props.onToggleExpand}
                />
                <p>11{item.SIP_number}</p>
              </StyledFlexCenter>
            </td>
            <td>
              <span className='d-block' style={{padding: '.08rem 0'}}>
                {item.customer?.title == null
                  ? item.customer?.name
                  : item.customer?.title + '-' + item.customer?.name}
              </span>
            </td>
            <td>
              <span className='d-block' style={{padding: '.08rem 0'}}>
                {t(item.sector?.name)}
              </span>
            </td>
          </tr>

          <tr className='fold' id={'target' + item.SIP_number}>
            <TableUI.TableDetail colSpan={4}>
              <TableUI.TableWrapper>
                <TableUI.Table>
                  <TableUI.THead>
                    <tr style={{backgroundColor: '#274070'}}>
                      <th>{t('sub-order-jenis')}</th>
                      <th>
                        {t('kontrak-produk')} {t('kode')}
                      </th>
                      <th>{t('sub-order-produk')}</th>
                      <th>{t('sub-order-kuantum')}</th>
                    </tr>
                  </TableUI.THead>
                  <TableUI.TBody>
                    {item?.order_sub_details?.map((item: any, index: any) => {
                      return (
                        <tr key={item?.product_name ?? index}>
                          <td>{item?.product_type_desc}</td>
                          <td>{item?.material_number.slice(-7)}</td>
                          <td>{item?.product_name}</td>
                          <td>{
                            (parseFloat(item?.fixed_quantum).toLocaleString(
                              i18next.language,
                                {
                                  maximumFractionDigits: 4,
                                }
                            ))
                            + (item?.sector_id == 3 ? ' MT' : ' Ton')
                            }</td>
                        </tr>
                      )
                    })}
                  </TableUI.TBody>
                </TableUI.Table>
              </TableUI.TableWrapper>
            </TableUI.TableDetail>
          </tr>
        </Fragment>
      ))}
    </>
  )
}
